"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _CalendarOptionButtonsList = _interopRequireDefault(require("./CalendarOptionButtonsList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AddBookingToCalendar = function AddBookingToCalendar(_ref) {
  var label = _ref.label,
      props = _objectWithoutProperties(_ref, ["label"]);

  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Block = _UX2$Element.Block,
      Minor = _UX2$Element.Details.Minor;
  var styles = {
    container: {
      marginTop: 'small',
      flexGrow: '1'
    },
    label: {
      marginBottom: 'xxsmall'
    }
  };
  return /*#__PURE__*/_react["default"].createElement(Block, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(Minor, {
    style: styles.label
  }, label), /*#__PURE__*/_react["default"].createElement(_CalendarOptionButtonsList["default"], props));
};

AddBookingToCalendar.propTypes = {
  booking: _propTypes["default"].shape({
    service: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      description: _propTypes["default"].string.isRequired
    }).isRequired,
    location: _propTypes["default"].shape({
      formatted_address: _propTypes["default"].shape({
        address_lines: _propTypes["default"].array.isRequired
      }).isRequired
    }),
    start_time: _propTypes["default"].string.isRequired,
    end_time_display: _propTypes["default"].string.isRequired
  }).isRequired,
  label: _propTypes["default"].string.isRequired,
  domainName: _propTypes["default"].string.isRequired,
  businessName: _propTypes["default"].string.isRequired,
  i18n: _propTypes["default"].object.isRequired,
  onAddToCalendarClick: _propTypes["default"].func,
  onAddToCalendarMount: _propTypes["default"].func
};
var _default = AddBookingToCalendar;
exports["default"] = _default;